<!--
Booking results screen
@author ab557z
-->
<template>
  <div id="contain" class="container">
  <Nav :name="bookingMessage" :step="true" :showNotif="true" />
      <Spinner ref="spinner" />
    <div v-if="!rooms || rooms.length == 0">
      <div class="alert alert-danger" style="margin-left:16px; margin-right:16px; margin-top:24px; background-color:var(--uog-dark-blue); color:white;" id="noResults" role="alert">
          <table>
            <tr>
              <td><img src="@/assets/error_white.svg" style="margin-top:-4px; margin-right:5px; margin-left:-5px;" /></td>
              <td v-html="resultsMessage" />
            </tr>
          </table>
        </div>
    </div>
    <div v-if="rooms && rooms.length > 0">
      <p class="bookingInstructions">
        Please select a room from the available list below.
      </p>
      <p style="color:var(--uog-dark-blue);font-weight:bold;margin-left:16px;margin-right:16px;margin-bottom:4px;">
        {{rooms.length}} Result<span v-if="rooms.length>1">s</span>
      </p>
      <RoomDisplay v-for="r in rooms"
          :room="r[1]"
          :key="r[0]"
          :date="search.bookingDate"
          :hideDate="true"
          :startTime="search.startTime"
          :endTime="search.endTime"
          :attendees="search.attendees"
          :capacity="r[2]"
          :hideAttendees="true"
          :location="r[0]"
          :showSelect="true" 
          :showNoFoodDrink="true"
          />
    </div>
    <div id="pusher"></div>
    <Footer active="findaspace"/>
  </div>
</template>

<script setup>
//Utilities
import axios from 'axios'
import {ref, onMounted} from 'vue'
import {useRoute} from 'vue-router'
const route = useRoute()

//Composables
import {useUserMethods} from '@/composables/UserMethods.js'
const {isStudent} = useUserMethods()

//Components
import RoomDisplay from '@/components/booking/RoomDisplay.vue'
import Spinner from '@/components/Spinner.vue'
import Footer from '@/components/FooterMenu.vue'

//Data
let bookingMessageInit = 'Book a Room'
if (isStudent()) {
  bookingMessageInit = 'Book a Study Room'
}

const rooms = ref([])
const resultsMessage = ref('Please wait while your results are loading.')
const results = ref(true)
const searchError = ref('')
const search = ref({})
const bookingMessage = ref(bookingMessageInit)

//Component refs
const spinner = ref(null)

onMounted(
  () => {
    createData()
    findRooms()
  }
)

function createData () {
  search.value.location = route.params.location
  search.value.bookingDate = route.params.bookingDate
  search.value.startTime = route.params.startTime
  search.value.endTime = route.params.endTime
  search.value.attendees = route.params.attendees
}

function findRooms () {
  spinner.value.spin()
  axios.post('/timetable/bookingv2/findrooms', search.value)
    .then(response => {
      if (Array.isArray(response.data)) {
        rooms.value = response.data
      } else {
        spinner.value.stop()
        let invalidFlag = true
      }
    })
    .catch(error => {
      const err = error.response.data
      if (typeof err !== 'undefined') {
        searchError.value = err.error
      }
    })
    .finally(() => {
      spinner.value.stop()
      if (rooms.value.length == 0) {
        let unavailableMsg = 'This room is not available'
        if (route.params.location === 'ALL') {
          unavailableMsg = 'There are no available rooms'
        }
        if (searchError.value !== '') {
          resultsMessage.value = 'An error occurred during your room search: <b>' + searchError.value + '</b>. <br />Please try again later.'
        } else {
          resultsMessage.value = unavailableMsg + ' based on your current search criteria. Please amend to try again.'
        }
      }
    })
}

</script>

<style scoped lang="scss">
p.bookingInstructions {
  margin-left:16px;
  margin-right:16px;
  margin-top:24px;
  margin-bottom:8px;
}
</style>
